<div class="flex flex-col w-full max-h-[600px] bg-white rounded-2xl overflow-hidden">
    <!-- Header -->
    <div class="flex justify-between items-center px-6 py-4">
        <div class="flex items-center gap-3">
            <div class="p-2 rounded-lg bg-purple-100">
                <mat-icon svgIcon="mat_solid:stars" class="icon-size-6 text-purple-600"></mat-icon>
            </div>
            <h2 class="text-[18px] font-semibold font-inter text-gray-900 m-0">
                {{ currentPlan?.name?.toLowerCase() === 'no_subscription' ? 'Escolher Plano' : 'Atualizar Plano' }}
            </h2>
        </div>
        <button
            mat-icon-button
            (click)="closeModal()"
            class="w-9 h-9 text-gray-500 hover:bg-gray-100 hover:text-gray-900 transition-all duration-200">
            <mat-icon class="icon-size-6" [svgIcon]="'mat_outline:close'"></mat-icon>
        </button>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="flex-1 p-6 pb-[86px] overflow-y-auto h-[420px]">
        <div class="flex flex-col items-center justify-center py-12">
            <mat-spinner diameter="40"></mat-spinner>
            <p class="mt-4 text-[14px] font-inter text-gray-500">Carregando planos...</p>
        </div>
    </div>

    <!-- Plans List -->
    <div *ngIf="!isLoading" class="flex-1 p-6 pb-[86px] overflow-y-auto h-[420px]">
        <!-- Card Explicativo -->
        <div class="mb-4 p-3 rounded-lg border"
             [ngClass]="{
                 'bg-blue-50 border-blue-200': currentPlan?.name?.toLowerCase() === 'no_subscription',
                 'bg-purple-50 border-purple-200': currentPlan?.name?.toLowerCase() !== 'no_subscription'
             }">
            <div class="flex items-start gap-2">
                <mat-icon
                    class="icon-size-5"
                    [ngClass]="{
                        'text-blue-600': currentPlan?.name?.toLowerCase() === 'no_subscription',
                        'text-purple-600': currentPlan?.name?.toLowerCase() !== 'no_subscription'
                    }"
                    [svgIcon]="currentPlan?.name?.toLowerCase() === 'no_subscription' ? 'mat_outline:info' : 'mat_outline:tips_and_updates'">
                </mat-icon>
                <div class="flex-1">
                    <p class="text-[13px] font-inter font-[500] m-0"
                       [ngClass]="{
                           'text-blue-900': currentPlan?.name?.toLowerCase() === 'no_subscription',
                           'text-purple-900': currentPlan?.name?.toLowerCase() !== 'no_subscription'
                       }">
                        {{ currentPlan?.name?.toLowerCase() === 'no_subscription' ? 'Escolha o plano ideal' : 'Mudança de plano' }}
                    </p>
                    <p class="text-[12px] font-inter mt-1 m-0 leading-relaxed"
                       [ngClass]="{
                           'text-blue-700': currentPlan?.name?.toLowerCase() === 'no_subscription',
                           'text-purple-700': currentPlan?.name?.toLowerCase() !== 'no_subscription'
                       }">
                        {{ currentPlan?.name?.toLowerCase() === 'no_subscription'
                           ? 'Selecione um plano de acordo com o tamanho e necessidades da sua igreja. Cada plano oferece recursos específicos para melhor atender sua comunidade.'
                           : 'Ao atualizar seu plano, a cobrança será ajustada proporcionalmente ao tempo restante do período atual. Upgrades são cobrados imediatamente, downgrades entram em vigor no próximo ciclo.' }}
                    </p>
                </div>
            </div>
        </div>

        <div class="space-y-3">
            <div
                *ngFor="let plan of plans"
                (click)="selectPlan(plan)"
                [class.opacity-50]="isCurrentPlan(plan)"
                [class.cursor-not-allowed]="isCurrentPlan(plan)"
                [class.cursor-pointer]="!isCurrentPlan(plan)"
                class="relative border-2 rounded-lg p-3 transition-all duration-200 hover:shadow-sm"
                [ngClass]="{
                    'border-[#0061ff] bg-blue-50': selectedPlan?.id === plan.id && !isCurrentPlan(plan),
                    'border-gray-200 bg-white': selectedPlan?.id !== plan.id && !isCurrentPlan(plan),
                    'border-green-200 bg-green-50': isCurrentPlan(plan)
                }">

                <!-- Current Plan Badge -->
                <div *ngIf="isCurrentPlan(plan)" class="absolute top-2 right-2">
                    <span class="px-2 py-0.5 rounded-full bg-green-100 text-green-700 text-[10px] font-inter font-[600]">
                        Plano Atual
                    </span>
                </div>

                <!-- Selected Badge -->
                <div *ngIf="selectedPlan?.id === plan.id && !isCurrentPlan(plan)" class="absolute top-2 right-2">
                    <div class="flex items-center gap-1 px-2 py-0.5 rounded-full bg-blue-100">
                        <mat-icon class="icon-size-3 text-blue-600" [svgIcon]="'mat_solid:check_circle'"></mat-icon>
                        <span class="text-blue-700 text-[10px] font-inter font-[600]">Selecionado</span>
                    </div>
                </div>

                <div class="flex items-start gap-3">
                    <!-- Plan Icon -->
                    <div class="p-2 rounded-lg" [ngClass]="getPlanBgColor(plan.name)">
                        <mat-icon
                            class="icon-size-6"
                            [ngClass]="getPlanMedalColor(plan.name)"
                            [svgIcon]="'mat_solid:military_tech'">
                        </mat-icon>
                    </div>

                    <!-- Plan Details -->
                    <div class="flex-1 min-w-0">
                        <div class="flex items-center gap-2 mb-1">
                            <h3 class="text-[15px] font-[600] font-inter text-gray-900">
                                {{ getPlanDisplayName(plan.name) }}
                            </h3>
                        </div>

                        <p class="text-[12px] font-inter text-gray-600 mb-3">
                            {{ plan.description }}
                        </p>

                        <div class="flex flex-col gap-1">
                            <!-- Preço regular -->
                            <div class="flex items-baseline gap-1">
                                <span class="text-[11px] font-inter text-gray-500">Valor mensal:</span>
                                <span class="text-[14px] font-[600] font-inter text-gray-900">
                                    {{ formatPrice(plan) }}
                                </span>
                                <span class="text-[11px] font-inter text-gray-500" *ngIf="!plan.billingUnit">/mês</span>
                            </div>

                            <!-- Diamond quando no_subscription: Cálculo maior + Valor final/mês -->
                            <ng-container *ngIf="currentPlan?.name?.toLowerCase() === 'no_subscription' && plan.name?.toLowerCase() === 'diamond' && plan.billingUnit && memberCount > 0 && !isCurrentPlan(plan)">
                                <!-- Cálculo detalhado -->
                                <div class="flex items-start gap-1 mt-1">
                                    <mat-icon class="icon-size-5 text-blue-600" [svgIcon]="'mat_outline:people'"></mat-icon>
                                    <span class="text-[13px] font-inter text-blue-700 leading-tight font-[500]">
                                        {{ memberCount }} membros × R$ {{ plan.price | number:'1.2-2':'pt-BR' }}
                                    </span>
                                </div>

                                <!-- Valor final/mês em destaque -->
                                <div class="flex items-baseline gap-1">
                                    <span class="text-[12px] font-inter text-blue-600">Valor final/mês:</span>
                                    <span class="text-[18px] font-[700] font-inter text-blue-600">
                                        R$ {{ (memberCount * plan.price) | number:'1.2-2':'pt-BR' }}
                                    </span>
                                </div>
                            </ng-container>

                            <!-- Valor imediato (pro-rata) - UPGRADE - Apenas quando HÁ subscription -->
                            <div *ngIf="currentPlan?.name?.toLowerCase() !== 'no_subscription' && plan.immediateChargeAmount !== undefined && plan.immediateChargeAmount !== null && plan.immediateChargeAmount > 0 && !isCurrentPlan(plan)"
                                 class="flex items-baseline gap-1">
                                <span class="text-[11px] font-inter text-blue-600">Cobrança imediata:</span>
                                <span class="text-[16px] font-[700] font-inter text-blue-600">
                                    {{ formatImmediateCharge(plan.immediateChargeAmount) }}
                                </span>
                            </div>

                            <!-- Mensagem de downgrade - próximo ciclo - Apenas quando HÁ subscription -->
                            <div *ngIf="currentPlan?.name?.toLowerCase() !== 'no_subscription' && plan.immediateChargeAmount !== undefined && plan.immediateChargeAmount !== null && plan.immediateChargeAmount === 0 && !isCurrentPlan(plan)"
                                 class="flex items-start gap-1 mt-1">
                                <mat-icon class="icon-size-4 text-orange-600" [svgIcon]="'mat_outline:info'"></mat-icon>
                                <span class="text-[11px] font-inter text-orange-700 leading-tight">
                                    {{ getDowngradeMessage() }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Pro-rata Info - Apenas quando HÁ subscription -->
        <div *ngIf="currentPlan?.name?.toLowerCase() !== 'no_subscription'" class="mt-3 p-2.5 pb-3 bg-blue-50 rounded-lg border border-blue-200">
            <div class="flex items-start gap-2">
                <mat-icon class="icon-size-4 text-blue-600" [svgIcon]="'mat_outline:info'"></mat-icon>
                <div class="flex-1">
                    <p class="text-[12px] font-inter text-blue-900 font-[500]">Ajuste Proporcional</p>
                    <p class="text-[12px] font-inter text-blue-700 mt-0.5">
                        A cobrança será ajustada proporcionalmente ao tempo restante do período atual.
                    </p>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer -->
    <div class="absolute flex bottom-0 left-0 right-0 p-6 w-full flex-row-reverse bg-white">
        <div class="relative h-[38px]">
            <button
                [disabled]="!selectedPlan || isUpdating"
                (click)="updatePlan()"
                class="h-full flex px-6 py-2 rounded-3xl bg-[#0061ff] hover:bg-[#2f75e7] relative cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
                <span class="mr-2 font-remote font-[400] text-[15px] text-white" *ngIf="!isUpdating">Confirmar</span>
                <mat-icon class="icon-size-5 text-white relative" [svgIcon]="'mat_solid:check'" *ngIf="!isUpdating"></mat-icon>
                <mat-progress-spinner *ngIf="isUpdating" [diameter]="18" [mode]="'indeterminate'" class="m-auto spinner-white"></mat-progress-spinner>
            </button>
        </div>
    </div>
</div>
